export default "__VITE_ASSET__F7uggoU7__"